import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/editIcon.svg'
import _imports_1 from '@/assets/deleteIcon.svg'


const _hoisted_1 = { class: "maincontainer py-8 px-4" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "Processes")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "flex mt-4"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, "Process name"),
    /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, "Created "),
    /*#__PURE__*/_createElementVNode("th", { class: "cursor-pointer" }, "Action")
  ])
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex flex-row align-center" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-5 w-5 mt-2"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "h-5 w-5 mt-2"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: { name: 'manageProcess' },
          class: "btnprimary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Add new")
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.processes.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("table", null, [
                _hoisted_6,
                (_ctx.processes.length > 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes, (process, processIndex) => {
                        return (_openBlock(), _createElementBlock("tr", { key: processIndex }, [
                          _createElementVNode("td", null, _toDisplayString(process.name), 1),
                          _createElementVNode("td", null, _toDisplayString(process.createdAt), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", {
                                class: "px-1 py-0 cursor-pointer",
                                onClick: ($event: any) => (_ctx.editProcess(process._id))
                              }, _hoisted_11, 8, _hoisted_9),
                              _createElementVNode("div", {
                                class: "px-1 py-0 cursor-pointer",
                                onClick: ($event: any) => (_ctx.deleteProcesses(process))
                              }, _hoisted_14, 8, _hoisted_12)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}